<template>
  <div class="md-layout md-alignment-center-space-between">
    <v-btn class="md-secondary" @click="showFeedbackDialog = true">
      Having trouble with the result?
    </v-btn>
    <v-dialog v-model="showFeedbackDialog" max-width="450">
      <v-card>
        <v-card-title>Request feedback</v-card-title>
        <v-card-text>
          <span class="md-body-1"
            >Please, share your feedback about the result:</span
          >
          <v-radio-group v-model="radioValue">
            <v-radio
              v-for="checkboxValue in checkboxValues"
              :key="checkboxValue"
              :label="checkboxValue"
              :value="checkboxValue"
            ></v-radio>
          </v-radio-group>
          <v-textarea
            v-model="textareaValue"
            outlined
            name="input-7-4"
            label="Tell us what was wrong with the result"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="onCloseClicked">Close</v-btn>
          <v-btn text :disabled="!radioValue" @click="sendData">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "RequestFeedback",
  props: {
    generatorData: Object,
  },
  data() {
    return {
      showFeedbackDialog: false,
      isOtherSelected: false,
      radioValue: "",
      textareaValue: "",
      checkboxValues: [
        "I don't understand the output",
        "I expected a different result/output",
        "The request has been detected (CAPTCHA, Cloudflare, etc.)",
        "Other",
      ],
    };
  },
  methods: {
    sendData() {
      this.$store
        .dispatch("feedback/sendRequestFeedback", {
          message: `${this.radioValue} | ${this.textareaValue}`,
          generatorData: this.generatorData,
        })
        .then(() => {
          this.clearInputs();
          this.$notify({
            group: "center",
            type: "success",
            text: "Thank you for the feedback. We'll get back to you soon.",
            duration: 1000,
          });
          this.showFeedbackDialog = false;
        })
        .catch(() => {
          this.$notify({
            group: "center",
            type: "error",
            text: "Failed to send the feedback. Please, try again later.",
            duration: 1000,
          });
        });
    },
    onCloseClicked() {
      this.clearInputs();
      this.showFeedbackDialog = false;
    },
    clearInputs() {
      this.radioValue = this.checkboxValues[0];
      this.textareaValue = null;
    },
  },
  mounted() {
    this.clearInputs();
  },
};
</script>

<style scoped>
.md-radio {
  display: flex;
}
</style>
